import React, { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import {
    FaClock, FaCheckCircle, FaTimesCircle, FaFire,
    FaSync, FaUserShield, FaChartBar, FaHistory
} from 'react-icons/fa';
import './css/Dashboard.css';


const Dashboard = () => {
    const [requests, setRequests] = useState([]);
    const [bonusMap, setBonusMap] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            // Bonus tanımlarını ve talepleri paralel çekiyoruz
            const [pendingRes, approvedRes, rejectedRes, bonusesRes] = await Promise.all([
                axiosInstance.get('/request'),
                axiosInstance.get('/request/approved'),
                axiosInstance.get('/request/rejected'),
                axiosInstance.get('/bonus/all') // Tüm bonusların olduğu endpoint (Senin sistemine göre ayarla)
            ]);

            // Bonus ID/Kodlarını isimlerle eşle: { "bonus-1": "Deneme Bonusu", "bonus-2": "Kayıp Bonusu" }
            const bMap = {};
            bonusesRes.data.forEach(b => {
                // Eğer veritabanında kod 'bonusCode' ise onu, değilse '_id'yi kullan
                const key = b.bonusType || b._id;
                bMap[key] = b.name;
            });
            setBonusMap(bMap);

            const allCombined = [
                ...(pendingRes.data || []),
                ...(approvedRes.data || []),
                ...(rejectedRes.data || [])
            ];
            setRequests(allCombined);
        } catch (err) {
            console.error("Dashboard veri hatası:", err);
        } finally {
            setLoading(false);
        }
    };

    // Atama Dağılımı Analizi
    const assignmentData = requests.reduce((acc, curr) => {
        if (curr.assignedTo) {
            acc[curr.assignedTo] = (acc[curr.assignedTo] || 0) + 1;
        }
        return acc;
    }, {});

    // Veriyi daha kolay dönmek için array'e çevirelim ve en çoktan aza sıralayalım
    const sortedAssignments = Object.entries(assignmentData)
        .map(([name, count]) => ({ name, count }))
        .sort((a, b) => b.count - a.count);

    const maxCount = sortedAssignments.length > 0 ? Math.max(...sortedAssignments.map(a => a.count)) : 1;
    const totalAssigned = sortedAssignments.reduce((sum, item) => sum + item.count, 0);

    const popularBonusCode = requests.length > 0 ?
        Object.entries(requests.reduce((acc, curr) => {
            acc[curr.bonusType] = (acc[curr.bonusType] || 0) + 1;
            return acc;
        }, {})).sort((a, b) => b[1] - a[1])[0][0] : null;

    const popularBonusName = bonusMap[popularBonusCode] || popularBonusCode || "Veri Yok";

    useEffect(() => {
        fetchDashboardData();
        const interval = setInterval(fetchDashboardData, 30000);
        return () => clearInterval(interval);
    }, []);

    // --- VERİ ANALİZİ ---
    // requests state'i artık birleşik olduğu için filter fonksiyonların çalışacak:
    const stats = {
        pending: requests.filter(r => r.status === 'pending').length,
        approved: requests.filter(r => r.status === 'approved').length,
        rejected: requests.filter(r => r.status === 'rejected').length,
        // En popüler bonusu bulmak için küçük bir kontrol:
        mostPopular: requests.length > 0 ?
            Object.entries(requests.reduce((acc, curr) => {
                acc[curr.bonusType] = (acc[curr.bonusType] || 0) + 1;
                return acc;
            }, {})).sort((a, b) => b[1] - a[1])[0][0] : "Veri Yok"
    };

    return (
        <div className="data-page-container">
            <header className="header-card">
                <div className="header-info">
                    <div className="title-with-icon">
                        <FaUserShield className="title-icon" />
                        <div>
                            <h2>Yönetim Özeti <span className="count-badge">Canlı</span></h2>
                            <p>Yönetim Paneli - Canlı Kontrol</p>
                        </div>
                    </div>
                </div>
            </header>

            {/* İstatistik Kartları */}
            <div className="stats-grid-dashboard">
                <div className="stat-premium-card b-blue">
                    <div className="stat-card-inner">
                        <div className="stat-icon-box"><FaClock /></div>
                        <div className="stat-content">
                            <span className="stat-label">Bekleyen Talepler</span>
                            <h3 className="stat-value">{stats.pending}</h3>
                        </div>
                    </div>
                </div>
                <div className="stat-premium-card b-green">
                    <div className="stat-card-inner">
                        <div className="stat-icon-box"><FaCheckCircle /></div>
                        <div className="stat-content">
                            <span className="stat-label">Toplam Onaylanan</span>
                            <h3 className="stat-value">{stats.approved}</h3>
                        </div>
                    </div>
                </div>
                <div className="stat-premium-card b-red">
                    <div className="stat-card-inner">
                        <div className="stat-icon-box"><FaTimesCircle /></div>
                        <div className="stat-content">
                            <span className="stat-label">Toplam Reddedilen</span>
                            <h3 className="stat-value">{stats.rejected}</h3>
                        </div>
                    </div>
                </div>
                <div className="stat-premium-card b-orange">
                    <div className="stat-card-inner">
                        <div className="stat-icon-box"><FaFire /></div>
                        <div className="stat-content">
                            <span className="stat-label">En Çok Talep Edilen</span>
                            <h3 className="stat-value" style={{ fontSize: '1.1rem' }}>{popularBonusName}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="dashboard-main-grid">
                {/* Sol: Son Talepler Akışı */}
                <div className="content-card-modern no-scroll-card">
                    <div className="card-header-inner">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <h3><FaHistory className="text-primary" /> Son Hareketler</h3>

                        </div>
                    </div>
                    <div className="modern-activity-list">
                        {requests
                            .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                            .slice(0, 5)
                            .map((req) => (
                                <div key={req._id} className={`modern-activity-item ${req.status}`}>
                                    {/* Mevcut içerik aynı kalıyor... */}
                                    <div className="activity-icon-wrapper">
                                        {req.status === 'approved' && <FaCheckCircle className="icon-approved" />}
                                        {req.status === 'rejected' && <FaTimesCircle className="icon-rejected" />}
                                        {req.status === 'pending' && <FaClock className="icon-pending" />}
                                    </div>
                                    <div className="activity-content-main">
                                        <div className="activity-top-row">
                                            <span className="user-label">{req.username}</span>
                                            <span className="time-stamp">{new Date(req.updatedAt).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</span>
                                        </div>
                                        <div className="activity-bottom-row">
                                            <div className="bonus-info-group">
                                                <span className="bonus-tag">{bonusMap[req.bonusType] || req.bonusType}</span>
                                                {/* Atama bilgisini buraya ekliyoruz */}
                                                {req.status === 'pending' && req.assignedTo && (
                                                    <span className="assignee-badge">
                                                        <FaUserShield size={10} /> {req.assignedTo}
                                                    </span>
                                                )}
                                            </div>
                                            <span className={`status-indicator-text ${req.status}`}>
                                                {req.status === 'approved' ? 'Onaylandı' : (req.status === 'rejected' ? 'Reddedildi' : 'Bekliyor')}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>

                {/* Sağ: Atama Dağılımı */}
                <div className="content-card-modern no-scroll-card highlight-card">
                    <div className="card-header-inner">
                        <div className="header-with-badge">
                            <h3><FaChartBar /> Atama Dağılımı</h3>
                            <span className="live-dot-pulse">Canlı</span>
                        </div>
                    </div>
                    <div className="operator-grid">
                        {/* Burada operatör sayısını da sınırlamak iyi bir fikir olabilir (örn .slice(0, 5)) 
                Çünkü operatör sayısı çoksa scroll kaçınılmaz olur. */}
                        {sortedAssignments.slice(0, 5).map((op, index) => {
                            const percentage = totalAssigned > 0 ? ((op.count / totalAssigned) * 100).toFixed(0) : 0;
                            return (
                                <div key={index} className="operator-card-mini">
                                    <div className="op-header-mini">
                                        <div className="op-info-mini">
                                            <span className="op-name-mini">{op.name}</span>
                                            <span className="op-count-mini">{op.count} Talep</span>
                                        </div>
                                        <span className="op-percent">%{percentage}</span>
                                    </div>
                                    <div className="progress-track-mini">
                                        <div className="progress-fill-gradient" style={{ width: `${percentage}%` }}></div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;